/** Intrinsic pixel dims of `public/sharpr.png`. Every `<img src="/sharpr.png">`
 *  rendered as `h-N w-auto` needs these so the browser reserves the correct
 *  aspect-ratio box before decode — a wrong or missing ratio makes the wordmark
 *  0px/mis-sized at first paint and shifts adjacent content (measured CLS
 *  contributor). If the PNG is re-exported at new proportions, update here and
 *  every call site follows. */
export const SHARPR_WORDMARK_DIMS = { width: 848, height: 332 } as const;
